import React, { useState } from "react";
import { putData } from "../../helpers/url-request";

export default function QueryMessageText({ text, canEdit, inspectionId, queryId, messageId = 0, onChanged }) {
  const [editing, setEditing] = useState(false);
  const [draft, setDraft] = useState("");
  const [original, setOriginal] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const save = async (event) => {
    event.preventDefault();
    if (busy) return;
    setBusy(true); setError("");
    try {
      const result = await putData(`/inspection/${inspectionId}/queries/${queryId}/messages/${messageId}/text`, { text: draft.trim(), originalText: original });
      if (!result?.status) throw new Error(result?.message || "Unable to save this message.");
      setEditing(false);
      await onChanged(queryId);
    } catch (reason) { setError(reason.message || "Unable to save this message."); }
    finally { setBusy(false); }
  };
  return <div className="query-message-text">
    {editing ? <form onSubmit={save}><textarea aria-label="Edit inspection message" autoFocus value={draft} maxLength={messageId ? 4000 : 2000} disabled={busy} onChange={(event) => setDraft(event.target.value)} /><div><button type="submit" disabled={busy || !draft.trim()}>{busy ? "Saving…" : "Save"}</button><button type="button" disabled={busy} onClick={() => { setEditing(false); setError(""); }}>Cancel</button></div></form>
      : <><p>{text}</p>{canEdit && <button type="button" className="query-message-edit" aria-label="Edit inspection message" title="Edit your message" onClick={() => { setDraft(text || ""); setOriginal(text || ""); setError(""); setEditing(true); }}><i className="bx bx-edit-alt" aria-hidden="true" /></button>}</>}
    {error && <p role="alert">{error}</p>}
  </div>;
}
